import * as React from 'react'
import {batch} from "@preact/signals-react";
import {Box} from "@mui/material";
import {SwitchSeeker} from "@ui-seeker/core";
import {postSubmit} from "@ui-seeker/utils";


import {NotAllowedBlock} from "@components";
import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import {keywordsTableData} from "../../@signals";


export default function booleanColumn(name, label) {
    return [{
        name: name,
        label: label,
        options: {
            display: 'excluded',
            customBodyRowRender: v => v ? 'Yes' : 'No'
        }
    },{
        name: name, label: label,
        options: {
            filter: false,
            customBodyRowRenderLite: (value, row) =>
                <BooleanColumnSwitch
                    value={value}
                    row={row}
                    name={name}
                    label={label}
                />
        }
    }]
}

const BooleanColumnSwitch = ({ value, row, name, label }) => {
    const { showToast } = useToast()

    const handleChange = () => {
        const updatedRow = { ...row, [name]: !value }
        batch(() => {
            showToast.promise(
                postSubmit(`${BACKEND_APIS.MANAGEMENT}/keywords/update-bool`, updatedRow)
                    .then(() => {
                        keywordsTableData.value = keywordsTableData.value.map(r =>
                            r.id === updatedRow.id ? updatedRow : r
                        )
                    })
                    .catch(() => {
                        showToast.error()
                    }),
                {
                    success: `${label} updated!`,
                    loading: 'Updating...',
                }
            )
        })
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {value === null ? (
                <NotAllowedBlock />
            ) : (
                <SwitchSeeker
                    formControlProps={{ sx: { margin: '0 auto' } }}
                    checked={!!value}
                    onChange={handleChange}
                />
            )}
        </Box>
    )
}